import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';

export default class Base extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    let model = super
      .payloadKeyFromModelName(modelName)
      .replace(/^posts\//, '');
    // Page templates just have a payload key of "template"
    if (model === 'page') {
      return 'template';
    }
    return model + 'Template';
  }

  modelNameFromPayloadKey(key) {
    // Page templates just have a payload key of "template"
    if (key === 'template') {
      key = 'page';
    } else if (key === 'templates') {
      key = 'page';
    }
    return super.modelNameFromPayloadKey(
      'posts/' + key.replace(/Template/i, ''),
    );
  }
}
